module.exports = __webpack_public_path__ + "static/img/image079.7c5a05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image079.png
// module id = Sdn+
// module chunks = 1